module.exports = __webpack_public_path__ + "img/icon-visa.6eddd303.svg";